import { COLORS, FONTS } from '../../constants';

const styles = theme => {
  // take mobile-first approach to do the styling

  const minMd = theme.breakpoints.up('md');

  return {
    root: {
      fontFamily: FONTS.PRIMARY,
      color: COLORS.GREY_DARK,
      paddingTop: 80,
      [minMd]: {
        paddingTop: 0,
      },
    },
    selectRoot: {
      width: '100%',
    },
    formTitle: {
      flex: 1,
      padding: '10px 0px 10px 20px',
      [minMd]: {
        padding: '40px 20px 10px 40px',
      },
    },
    subTitle: {
      flex: 1,
      padding: '0px 0px 10px 20px',
      [minMd]: {
        padding: '0px 0px 10px 40px',
      },
    },
    heading: {
      textAlign: 'center',
      color: COLORS.BLACK,
      margin: '0 0 20px 0',
      fontWeight: 700,
      fontSize: '1.5rem',
      [minMd]: {
        textAlign: 'left',
        fontSize: '2.25rem',
      },
    },
    topCloseButton: {
      zIndex: 999,
      position: 'fixed',
      right: 5,
      top: 14,
      color: COLORS.WHITE,
      [minMd]: {
        top: 0,
        right: 0,
        color: COLORS.GREEN,
        position: 'absolute',
      },
    },
    toolBar: {
      position: 'fixed',
      zIndex: 9,
      top: 0,
      left: 0,
      width: '100%',
      backgroundColor: COLORS.GREEN,
      padding: '15px 15px 15px 20px',
      borderBottom: `2px solid ${COLORS.GREEN_LIGHT}`,
      [minMd]: {
        display: 'none',
      },
    },
    plannedStartDate: {
      fontSize: '100px',
      width: '100%',
      color: 'red',
    },
  };
};

export default styles;
